import { useUserStore } from '../../../../../modules/Auth/stores/authStore';
import CircularProgressBar from '../../../atoms/CircularProgressBar';
import { Icon } from '../../../atoms/Icon';
import { Typography } from '../../../molecules/Typography';

interface ExamFeedbackStatusProps {
  correctAnswersPercentage: number;
  correctAnswersTotal: number;
  wrongAnswersTotal: number;
  timeSpent: number | null;
  essayStatus?: string;
}

const ExamFeedbackStatus = ({
  correctAnswersPercentage,
  correctAnswersTotal,
  wrongAnswersTotal,
  timeSpent,
  essayStatus,
}: ExamFeedbackStatusProps) => {
  const { user } = useUserStore();

  return (
    <>
      <div className='flex flex-col gap-sm text-center xl:max-w-sm xl:text-start'>
        {correctAnswersPercentage >= 50 ? (
          <>
            <Typography size='h3' type='title'>
              No caminho para a aprovação!
            </Typography>
            <Typography>
              Mas não relaxe: treinar todos os dias é essencial!
            </Typography>
          </>
        ) : (
          <>
            <Typography size='h3' type='title'>
              {/* Convidado nao tem usuario na plataforma: sem nome, sem virgula. */}
              Treine um pouco mais{user?.name ? `, ${user.name}` : ''}!
            </Typography>
            <Typography>
              Mantenha a consistência nos estudos que os resultados começarão a
              aparecer!
            </Typography>
          </>
        )}
      </div>
      <div>
        <CircularProgressBar percentage={correctAnswersPercentage} />
      </div>
      <div className='flex flex-col gap-xxl'>
        <div className='flex gap-xxl'>
          <div className='flex gap-sm'>
            <Icon
              Icon='done'
              className='text-feedback-color-success-pure'
              type='material'
            />
            <Typography>
              {correctAnswersTotal}
              {correctAnswersTotal === 1 ? ' acerto' : ' acertos'}
            </Typography>
          </div>
          <div className='flex gap-sm'>
            <Icon
              Icon='close'
              className='text-feedback-color-error-pure'
              type='material'
            />
            <Typography>
              {wrongAnswersTotal}
              {wrongAnswersTotal === 1 ? ' erro' : ' erros'}
            </Typography>
          </div>
          {timeSpent !== null && timeSpent > 0 && (
            <div className='flex gap-sm xs:flex lg:hidden'>
              <Icon
                Icon='schedule'
                type='material'
                className='text-mono-color-dark'
              />
              <Typography>{timeSpent}</Typography>
            </div>
          )}
        </div>
        {essayStatus && (
          <div className='flex gap-sm'>
            <Icon
              Icon='edit'
              type='material'
              className='text-mono-color-dark'
            />
            <Typography>
              {essayStatus === 'writing' &&
                'Redação salva como rascunho (não enviada)'}
              {essayStatus === 'sent' && 'Redação enviada para correção'}
              {essayStatus === 'corrected' && 'Redação corrigida'}
            </Typography>
          </div>
        )}
        {timeSpent !== null && timeSpent > 0 && (
          <div className='flex gap-sm xs:hidden lg:flex'>
            <Icon
              Icon='schedule'
              type='material'
              className='text-mono-color-dark'
            />
            <Typography>{new Date(timeSpent).toLocaleTimeString()}</Typography>
          </div>
        )}
      </div>
    </>
  );
};

export default ExamFeedbackStatus;
